import styled from 'styled-components';
import media from '../../styled/media';

export const Intro = styled.div`
  padding: 0;
  padding-bottom: 30px;
  ${media.tablet`
    padding: 50px 0;
  `}
`;

export const IntoCells = styled.div`
  display: flex;
  gap: 25px;
  flex-direction: column;
  align-items: center;
  h1,
  p {
    text-align: center;
  }
  ${media.tablet`
    flex-direction: row;
    align-items: flex-start;
    h1, p {
      text-align: start;
    }
    h1 {
      margin-top: 0;
    }
  `}
`;

export const IntoCell = styled.div`
  ${media.tablet`
    width: calc(100% / 3);
    max-width: 455px;
  `}
`;

export const IntoSteps = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  ${media.tablet`
    gap: 0;
    flex-direction: row;
    justify-content: space-around;
  `}
`;

export const IntoStep = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: space-between;
  ${media.tablet`
    max-width: 300px;
    h4 {
      text-align: center;
    }
  `}
`;

export const IntroHeading = styled.h1`
  font-weight: 400;
  text-transform: uppercase;
  ${media.tablet`
    font-size: 48px;
    line-height: 48px;
  `}
`;

export const IntroDescription = styled.p`
  font-weight: 400;
  text-transform: uppercase;
  ${media.tablet`
    margin-top: 18px;
    margin-bottom: 60px;
    font-size: 18px;
  `}
`;

export const Ul = styled.ul`
  margin-bottom: 35px;
  display: flex;
  flex-direction: column;
  gap: 34px;
  list-style-type: none;
  li {
    position: relative;
    padding-left: 34px;
    font-size: 18px;
    line-height: 27px;
  }
  li::before {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    width: 24px;
    height: 26px;
    background-image: url('/images/footscanner/bullet-red.svg');
  }
  ${media.tablet`
    margin-bottom: 105px;
  `}
`;

export const UnlockFuture = styled.div`
  padding: 20px 0;
  background: #f5f5f5;
  ${media.tablet`
    padding: 50px 0;
  `}
`;

export const UnlockFutureCells = styled.div`
  display: flex;
  flex-direction: column-reverse;
  ${media.tablet`
    flex-direction: row;
  `}
`;

export const UnlockFutureCell = styled.div`
  position: relative;
  margin: 0 auto;
  padding: 20px 0;
  width: max-content;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  video {
    height: 500px;
    box-shadow: 2px 2px 10px 0 rgba(0 0 0 / 15%);
    border-radius: 10px;
  }
  p,
  h3 {
    text-align: center;
  }
  ${media.tablet`
    padding: 0;
    width: 50%;
    align-items: flex-start;
    justify-content: center;
    video {
      height: 510px;
    }
    p, h3 {
      text-align: start;
    }
  `}
`;

export const H3 = styled.h3`
  margin-top: 30px;
  margin-bottom: 24px;
  font-size: 24px;
  line-height: 36px;
  font-weight: 400;
  ${media.tablet`
    font-size: 34px;
    line-height: 48px;
  `}
`;

export const Text = styled.p`
  margin: 0;
  font-size: 18px;
  line-height: 27px;
  font-weight: 400;
`;

export const HowWorks = styled.div`
  padding: 20px 0 50px 0;
  h3 {
    text-align: center;
  }
`;

export const HowWorksInner = styled.div`
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  ${media.tablet`
    margin-top: 72px;
    flex-direction: row;
  `}
`;

export const Divider = styled.span`
  width: 100%;
  height: 1px;
  background-color: #dcdcdc;
  ${media.tablet`
    width: 1px;
    height: auto;
  `}
`;

export const HowWorksCell = styled.div`
  ${media.tablet`
    max-width: 288px;
  `}
  h4 {
    margin-top: 0;
    text-align: center;
  }
`;

export const H4 = styled.h4`
  font-size: 18px;
  line-height: 24px;
  font-weight: 400;
  ${media.tablet`
    font-size: 24px;
    line-height: 36px;
  `}
`;

export const HowWorksCellText = styled(Text)`
  font-size: 16px;
  text-align: center;
`;

export const Recommendations = styled.div`
  padding: 0;
  padding-bottom: 30px;
  background: #f5f5f5;
  ${media.tablet`
    padding: 50px 0;
  `}
`;

export const RecommendationsInner = styled.div`
  display: flex;
  flex-direction: column-reverse;
  gap: 20px;
  ${media.tablet`
    flex-direction: row;
    align-items: flex-start;
    gap: 50px;
  `}
`;

export const RecommendationsCell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  p {
    text-align: center;
  }
  ${media.tablet`
    gap: 24px;
    align-items: flex-start;
    width: 50%;
    p {
      text-align: start;
    }
  `}
`;

export const Assurance = styled.div`
  padding: 0;
  padding-bottom: 30px;
  ${media.tablet`
    padding: 50px 0;
  `}
`;

export const AssuranceInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  ${media.tablet`
    flex-direction: row;
    gap: 50px;
  `}
`;

export const AssuranceCell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  p {
    text-align: center;
  }
  ${media.tablet`
    align-items: flex-start;
    justify-content: center;
    gap: 24px;
    width: 50%;
    p {
      text-align: start;
    }
  `}
`;

export const FootSizingSolution = styled.div`
  padding: 0;
  padding-bottom: 30px;
  border-top: 5px solid #f5f5f5;
  ${media.tablet`
    padding: 50px 0;
  `}
`;

export const FootSizingSolutionInner = styled.div`
  display: flex;
  flex-direction: column-reverse;
  gap: 20px;
  ${media.tablet`
    flex-direction: row;
    gap: 50px;
  `}
`;

export const FootSizingSolutionCell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  p {
    text-align: center;
  }
  ${media.tablet`
    align-items: flex-start;
    justify-content: center;
    gap: 24px;
    width: 50%;
    p {
      text-align: start;
    }
  `}
  iframe {
    border: 0;
  }
`;

export const Benefits = styled.div`
  padding: 0;
  padding-bottom: 30px;
  background: #f5f5f5;
  ${media.tablet`
    padding: 20px 0 50px 0;
  `}
  h3, h4 {
    text-align: center;
  }
`;

export const BenefitsItems = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  ${media.tablet`
    margin-top: 50px;
    flex-direction: row;
    justify-content: center;
    gap: 60px;
  `}
`;

export const BenefitsItem = styled.div`
  width: 288px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 30px;
  width: max-content;
  ${media.tablet`
    flex-direction: column;
    gap: 0;
  `}
  h4 {
    text-align: center;
  }
`;

export const ECom = styled.div`
  h3,
  h4 {
    text-align: center;
  }
`;

export const BookMeating = styled.div`
  display: flex;
  align-items: center;
  min-height: 300px;
  background-repeat: no-repeat;
  background-image: url('/images/footscanner/book-meeting.jpg');
  background-position-x: calc(100% + 400px);
  background-position-y: -100px;
  ${media.tablet`
    padding: 20px 0 50px 0;
    min-height: 608px;
    background-position-x: right;
    background-position-y: unset;
  `}
`;

export const BookMeatingInner = styled.div`
  margin: 0 auto;
  padding: 0 20px;
  max-width: 1260px;
  width: 100%;
`;

export const WrapperCentered = styled.div`
  margin: 0 auto;
  width: max-content;
`;
